export type MachineViewMode = 'cards' | 'table';
export function machineViewMode(value: string | null): MachineViewMode {
  return value === 'table' ? 'table' : 'cards';
}
const normalize = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase();
export function filterMachines(items: any[], search: string, department: string) {
  const words = normalize(search.trim()).split(/\s+/).filter(Boolean);
  return items.filter(item => {
    if (department && item.department_id !== department) return false;
    const text = normalize([item.code, item.name, item.department_name, item.workshop_area,
      ...(item.operators ?? []).map((o: any) => o.fullName)].filter(Boolean).join(' '));
    return words.every(word => text.includes(word));
  });
}
export function printerRecentlyOnline(printer: any, now = Date.now()) {
  // Server-reported heartbeat avoids hiding devices when the phone clock is wrong.
  if (typeof printer.gateway_online === 'boolean') return printer.raster_verified === true && printer.gateway_online;
  const age = now - Date.parse(printer.last_seen ?? '');
  return printer.raster_verified === true && Number.isFinite(age) && age >= -5000 && age < 60_000;
}
